import { useEffect } from "react";
import { Navigate } from "react-router-dom";

// Legacy route. The 3-tile chooser (vendor / couple / sign-in) is gone —
// /signin now handles couple sign-up and admin sign-in. /login simply
// redirects so old bookmarks keep working.
const Login = () => {
  useEffect(() => {
    document.title = "Sign in · Luxé Directory";
  }, []);
  return <Navigate to="/signin" replace />;
};

export default Login;
